import { useEffect, useState } from "react";
import { ChevronRight, X } from "lucide-react";

// 우측에서 슬라이드로 열리는 패널 — 리스트를 보며 연속 작업하는 운영 화면(크레딧 조정 등)에서
// 중앙 모달 방식보다 작업 맥락 유지에 유리해 드로어로 둠(QA CRD-001).
// wide: 사용자 상세(도구·엔진별/모델별/세션 표 등 칼럼이 많은 콘텐츠)처럼 448px로는
// 답답한 내용을 위한 넓은 변형(2026-07-15, 인라인 토글이 표를 옆으로 너무 넓혀서 사이드
// 패널로 전환).
//
// 열기/닫기 애니메이션(2026-07-15) — instant show/hide 대신 슬라이드 트랜지션. open=false가
// 되는 즉시 언마운트하면 트랜지션이 재생될 시간이 없어서, mounted 를 한 프레임 늦게 끄는
// 방식으로 처리(mounted: DOM에 있는지, visible: translate/opacity 상태).
export default function Drawer({ open, onClose, title, children, wide = false }) {
  const [mounted, setMounted] = useState(open);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const raf = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(raf);
    }
    setVisible(false);
    const t = setTimeout(() => setMounted(false), 200); // duration-200 과 맞춤
    return () => clearTimeout(t);
  }, [open]);

  if (!mounted) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex justify-end bg-ink-950/50 transition-opacity duration-200 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
      onClick={onClose}
    >
      <div
        className={`relative flex h-full w-full flex-col bg-white transition-transform duration-200 ease-out ${
          wide ? "max-w-3xl" : "max-w-md"
        } ${visible ? "translate-x-0" : "translate-x-full"}`}
        style={{ boxShadow: "-24px 0 48px -16px rgba(15, 23, 42, 0.35)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 왼쪽 모서리 중앙의 닫기 핸들 — 우상단 ✕ 외에 시각적으로 "여기가 패널 경계"라는
            안정감을 주는 보조 버튼(피드백: 디자인적 안정감). */}
        <button
          type="button"
          onClick={onClose}
          title="패널 닫기"
          className="absolute left-0 top-1/2 z-10 flex h-10 w-7 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-ink-400 shadow-[0_2px_10px_rgba(15,23,42,0.16)] transition-colors hover:text-brand-600"
        >
          <ChevronRight className="h-4 w-4" />
        </button>

        <div className="flex items-center justify-between border-b border-ink-100 px-5 py-4">
          <h2 className="text-sm font-semibold text-ink-900">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="닫기"
            className="flex h-7 w-7 items-center justify-center rounded-lg text-ink-400 hover:bg-ink-100 hover:text-ink-700"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto bg-ink-50/60 px-5 py-4">{children}</div>
      </div>
    </div>
  );
}
